<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="my-2">
              <div class="row">
                <b-form-group class="col-md-3" label="Term">
                  <v-select
                    :options="schoolterms"
                    placeholder="Select Term"
                    v-model="schoolterm"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-2" label="Year">
                  <v-select
                    :options="years"
                    placeholder="Select Year"
                    v-model="year"
                    label="name"
                  ></v-select>
                </b-form-group>
                <b-form-group class="col-md-3" label="Class">
                  <v-select
                    :options="schoolclasses"
                    placeholder="Select Class"
                    v-model="schoolclass"
                    label="name"
                  ></v-select>
                </b-form-group>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"
                    ><i class="mdi mdi-account-search"></i> Filter</b-button
                  >
                </div>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <export-excel
                    class="btn btn-info"
                    :data="exammarks"
                    name="StudentsReport.xls"
                  >
                    Export <i class="mdi mdi-download"></i
                  ></export-excel>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="text-center mt-4" v-if="schoolstream != ''">
              <h3>
                {{ schoolclass.name }}{{ schoolstream.name }}
                {{ schoolterm.name }} {{ year }}
              </h3>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Selected Yet</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student_id)="data">
                  <b class="text-danger">{{ data.item.student.student_id }}</b>
                  <br />
                </template>
                <template #cell(student)="data">
                  {{ data.item.student.first_name }}
                  {{ data.item.student.last_name }} <br />
                  <small
                    ><b>{{ data.item.student.student_id }}</b></small
                  >
                </template>
                <template #cell(class)="data">
                  {{ data.item.class.name }} {{ data.item.stream.name }}
                </template>
                <template #cell(fees)="data">
                  {{ commas(data.item.fees) }}
                </template>
                <template #cell(total)="data">
                  {{ commas(data.item.total) }}
                </template>
                <template #cell(exemptions)="data">
                  {{ commas(data.item.exemptions) }}
                </template>
                <template #cell(previousbalances)="data">
                  {{ commas(data.item.previousbalances) }}
                </template>
                <template #cell(balance)="data">
                  <span v-if="data.item.bursary.bursarytype == 'Full Bursary'">
                    0
                  </span>
                  <span
                    v-else-if="data.item.bursary.bursarytype == 'Half Bursary'"
                  >
                    {{
                      commas(
                        Number(
                          (Number(data.item.total) +
                            Number(data.item.previousbalances)) /
                            2,
                        ) -
                          Number(data.item.fees) -
                          Number(data.item.exemptions),
                      )
                    }}
                  </span>
                  <span v-else-if="data.item.bursary.bursarytype == 'Custom'">
                    {{
                      commas(
                        Number(data.item.bursary.bursaryvalue) +
                          Number(data.item.previousbalances) -
                          Number(data.item.fees) -
                          Number(data.item.exemptions),
                      )
                    }}
                  </span>
                  <span
                    v-else-if="data.item.bursary.bursarytype == 'Percentage'"
                  >
                    {{
                      commas(
                        Number(
                          (Number(data.item.total) +
                            Number(data.item.previousbalances)) *
                            (data.item.bursary.bursaryvalue / 100),
                        ) -
                          Number(data.item.fees) -
                          Number(data.item.exemptions),
                      )
                    }}
                  </span>
                  <span v-else>
                    {{
                      commas(
                        Number(
                          Number(data.item.total) +
                            Number(data.item.previousbalances),
                        ) -
                          Number(data.item.fees) -
                          Number(data.item.exemptions),
                      )
                    }}
                  </span>
                </template>
                <template #cell(bursary)="data">
                  <span v-if="data.item.bursary.bursarytype == 'Full Bursary'">
                    <small class="text-success"
                      ><b>{{ data.item.bursary.bursarytype }}</b></small
                    >
                    <br />
                    {{ commas(data.item.total) }}
                  </span>
                  <span
                    v-else-if="data.item.bursary.bursarytype == 'Half Bursary'"
                  >
                    <small class="text-success"
                      ><b>{{ data.item.bursary.bursarytype }}</b></small
                    >
                    <br />
                    {{ commas(data.item.total / 2) }}
                  </span>
                  <span v-else-if="data.item.bursary.bursarytype == 'Custom'">
                    <small class="text-success"
                      ><b>{{ data.item.bursary.bursarytype }}</b></small
                    >
                    <br />
                    {{ commas(data.item.bursary.bursaryvalue) }}
                  </span>
                  <span
                    v-else-if="data.item.bursary.bursarytype == 'Percentage'"
                  >
                    <small class="text-success"
                      ><b
                        >{{ data.item.bursary.bursarytype }} -
                        {{ data.item.bursary.bursaryvalue }}</b
                      ></small
                    >
                    <br />
                    {{
                      commas(
                        data.item.total *
                          (data.item.bursary.bursaryvalue / 100),
                      )
                    }}
                  </span>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="edit(data.item.id, data.item.student.student_id)"
                      type="button"
                      class="btn-sm btn"
                      title="Ledger"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Fees Payable : {{ commas(totalfees) }}</b>
              </div>
              <div class="col">
                <b>Exemptions : {{ commas(totalexemption) }}</b>
              </div>
              <div class="col">
                <b>Amount Paid : {{ commas(totalpaid) }}</b>
              </div>
              <div class="col">
                <b>
                  Balance :
                  {{ commas(totalfees - (totalpaid + totalexemption)) }}</b
                >
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
// import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  feespaymentMethods,
  feespaymentComputed,
  schoolclassMethods,
  schoolclassComputed,
  schooltermMethods,
  schooltermComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Fees Summaries",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Summaries",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Summaries", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_id", label: "Student ID", visible: true },
        { key: "student", label: "Name", visible: true },
        { key: "total", label: "Fees Amount", visible: true },
        { key: "fees", label: "Amount Paid", visible: true },
        { key: "previousbalances", label: "Previous Balance", visible: true },
        { key: "exemptions", label: "Exemptions", visible: true },
        { key: "bursary", label: "Bursary", visible: true },
        { key: "balance", label: "Balance", visible: true },
      ],
      id: "",
      name: "",
      schoolterm: "",
      schoolclass: "",
      schoolstream: "",
      schoolstreams: [],
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...feespaymentComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.feespayments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.feespayments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.feespayments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
    totalfees() {
      var total = 0;
      this.feespayments.forEach((item) => {
        var item_total = item.total;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalexemption() {
      var total = 0;
      this.feespayments.forEach((item) => {
        var item_total = item.exemptions;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalpaid() {
      var total = 0;
      this.feespayments.forEach((item) => {
        var item_total = item.fees;
        total = Number(total) + Number(item_total);
      });
      return total;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.feespayments.length;
    this.isBusy = false;
  },
  methods: {
    ...feespaymentMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FilterData() {
      this.filterFeesPayments({
        schoolterm: this.schoolterm.id,
        year: this.year,
        schoolclass: this.schoolclass.id,
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
